import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'

import FlatButton from 'material-ui/FlatButton';
import { Card, CardTitle } from 'material-ui/Card';
import question from '../../question'

// Component 

export const Questions = ({questions, qid, answers, result, user, onPrev, onNext, onSubmit, onReset}) => {
  var current = questions[qid];
  return (
    <div>
      { result < 0 ?
        <question.components.Question key={'p'+qid} id={qid} text={current.text} count={questions.length}/> :
        <Card><CardTitle title={'The respondent belongs to Indian Segment '+(result+1)} /></Card>
      }

      <FlatButton label="Reset" onTouchTap={onReset} />
      <FlatButton label="Prev" onTouchTap={onPrev} disabled={qid == 0} />
      <FlatButton label="Next" onTouchTap={onNext} disabled={((qid >= questions.length - 1) || (answers[qid] == undefined) || answers[qid] ==  0)} />
      <FlatButton label="Submit" onTouchTap={() => onSubmit(answers, user)} disabled={(qid < questions.length - 1) || (result >= 0)} />
    </div>
  )
}

Questions.propTypes = {
}

// Container

const mapStateToProps = (state) => {
  return { questions: state.questions.questions, answers: state.question, qid: state.questions.qid, result: state.questions.result, user: state.user }
}

const filterInt = function (value) {
  //if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
  if(/^[0-9]$/.test(value))
    return Number(value);
  return -1;
}

const mapDispatchToProps = (dispatch) => {
  return {
    onReset: () => {
      dispatch(dispatch => {
        dispatch({type: 'question/RESET'})
        setTimeout(() => dispatch(actions.reset()), 200)
      })
      if (__DEV__) console.log('Reset');
    },
    onPrev: () => {
      dispatch(actions.prev())
      if (__DEV__) console.log('Prev');
    },
    onNext: () => {
      dispatch(actions.next())
      if (__DEV__) console.log('Next');
    },
    onSubmit: (answers, user) => {
      let fetchoptions = {
          redirect: 'error',
          headers: {
            'Authorization': 'Basic '+(new Buffer(user.email+":"+user.password).toString("base64")),
          }
        }
      fetch('/app/s/' + answers.join('/'), fetchoptions).then((response) => {
        if(response.ok) {
          dispatch(actions.result(filterInt(response.headers.get('x-Segment'))));
        }
      })
      if (__DEV__) console.log('Submit');
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Questions)



// WEBPACK FOOTER //
// ./src/questions/components/Questions.js